import { Directive, ElementRef, HostListener, Input, AfterViewInit, Optional } from '@angular/core';
import { ControlContainer, FormGroupDirective, NgControl } from '@angular/forms';
import { TelefoneDirective } from '../telefone/telefone.directive';

@Directive({
  selector: '[appShowErrorMessages]'
})
export class ShowErrorMessagesDirective implements AfterViewInit {

  @Input() dateMessage?: string;
  @Input() dateRangeMessage?: string;
  @Input() dateRangeMonthMessage?: string;
  @Input() requiredMessage = 'Campo obrigatório';
  @Input() invalidMessage = 'Valor inválido';
  @Input() customErrorMessage = 'Valor inválido';
  @Input() duplicidadeMessage?: string;
  @Input() patternMessage = 'Formato inválido';
  @Input() cpfUtilizadoMessage = 'O CPF não pode ser igual ao de um sócio ou de outro avalista.';
  @Input() telefoneUtilizadoMessage = 'O Celular do avalista não pode ser o mesmo do cliente ou sócio.';
  @Input() genericErrorMessage = 'Valor inválido';

  private _idElementMessage: string;

  constructor(
    private _el: ElementRef, 
    private _fg: ControlContainer, 
    private formControl: NgControl,
    @Optional() private telefoneDirective?: TelefoneDirective) {
  }

  ngAfterViewInit() {
    this.createIdElementMessage();
  }

  @HostListener('focus', ['$event'])
  onFocus() {
    this.removeComponentMessage();
  }

  @HostListener('blur', ['$event'])
  showErrorMessages() {
    const inputValue = this._el.nativeElement.value;
    if (this.control && this.control.setValue && this.isAllowedInput()) {
      this.control.setValue(inputValue, { emitEvent: true });
      this.control.updateValueAndValidity();
    }
    this.removeComponentMessage();
    if (this.control.errors) {
      this.showMessage(this.getErrorMessage(this.control.errors));
    }
  }

  private createIdElementMessage() {
    this._idElementMessage = `${this.elementName}-error-message`;
  }

  private showMessage(message: string) {
    this._el.nativeElement.insertAdjacentHTML('afterend', `<div id="${this._idElementMessage}" class="text-danger">${message}</div>`);
  }

  private removeComponentMessage() {
    const el = document.getElementById(this._idElementMessage);
    if (el) {
      el.remove();
    }
  }

  private getErrorMessage(errors: any): string {
    if (errors.required) { return this.requiredMessage; }
    if (errors.email) { return 'O email informado é inválido'; }
    if (errors.message) { return errors.message; }
    if (errors.minlength) { return `${this.invalidMessage}, quantidade miníma de caracteres: ${errors.minlength.requiredLength}`; }
    if (errors.email) { return 'E-mail inválido'; }
    if (errors.min) { return `Valor mínimo permitido é ${errors.min.min}`; }
    if (errors.max) { return `Valor máximo permitido é ${errors.max.max}`; }
    if (errors.dateCheck && this.dateMessage) { return this.dateMessage; }
    if (errors.dateRange && this.dateRangeMessage) { return this.dateRangeMessage; }
    if (errors.dateRangeMonth && this.dateRangeMonthMessage) { return this.dateRangeMonthMessage; }
    if (errors[`${this.elementName}Error`]) { return this.customErrorMessage; }
    if (errors.duplicidade && this.duplicidadeMessage) { return this.duplicidadeMessage; }
    if (errors.pattern) { return this.patternMessage; }
    if (errors.futureDate) { return 'A data não pode ser maior que o dia de hoje'; }
    if (errors.cpfUtilizado) { return this.cpfUtilizadoMessage ? this.cpfUtilizadoMessage : 'O CPF não pode ser igual ao de um sócio ou de outro avalista.'; }
    if (errors.maxlength) { return `${this.invalidMessage}, quantidade máxima de caracteres: ${errors.maxlength.requiredLength}`; }
    if (errors.dataEmissaoFutura) { return 'A data de emissão do documento não pode ser menor que a data de nascimento.'; }
    if (errors.telefoneUtilizado) { return this.telefoneUtilizadoMessage ? this.telefoneUtilizadoMessage : 'O Celular do avalista não pode ser o mesmo do cliente ou sócio.'; }
    if (errors.genericErrorMessage) { return this.genericErrorMessage ? this.genericErrorMessage : 'Valor inválido'; }
    if (errors.mask) { return `Formato inválido. Formato esperado: ${errors.mask.requiredMask}`; }
    return JSON.stringify(errors);
  }

  get form() { return this._fg.formDirective ? (this._fg.formDirective as FormGroupDirective).form : null; }

  get control(): any {
    return this.form.controls[this.elementName] || {};
  }

  get elementName(): string {
    if (this._el.nativeElement.name) {
      return this._el.nativeElement.name;
    }

    if (this.formControl.name) {
      return this.formControl.name.toString();
    }

    throw new Error('Para utilizar a diretiva appShowErrorMessages a tag deve possuir o atributo "name".');
  }

  private isAllowedInput(): boolean {
    const tag = this._el.nativeElement.tagName;

    const isPhone = this._el.nativeElement.getAttribute("type") === 'user-phone' ||
                    !!this.telefoneDirective ||
                    this._el.nativeElement.type === 'tel';

    const isEmail = this._el.nativeElement.name.includes('email') || 
                    this._el.nativeElement.id.includes('email');

    return tag === 'INPUT' && (isEmail || isPhone);
  }
}
